import { render, staticRenderFns } from "./SummaryList.vue?vue&type=template&id=13139953"
import script from "./SummaryList.ts?vue&type=script&lang=ts&external"
export * from "./SummaryList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports